import { CalendarDays, ClipboardList, FileSignature, Files, Home, type LucideIcon, UserRound } from "lucide-react";

export interface NavItem {
  title: string;
  /** Route path. Typed as string to mirror provider's nav convention. */
  to: string;
  icon: LucideIcon;
}

/** Primary patient navigation. Shared by the desktop sidebar and mobile drawer. */
export const navItems: NavItem[] = [
  { title: "Home", to: "/", icon: Home },
  { title: "Appointments", to: "/appointments", icon: CalendarDays },
  { title: "Questionnaires", to: "/questionnaires", icon: ClipboardList },
  { title: "Documents", to: "/documents", icon: Files },
  { title: "Consent forms", to: "/consent-forms", icon: FileSignature },
  { title: "Profile", to: "/profile", icon: UserRound },
];
